import type { FC, HTMLAttributes } from "react";

import { cn } from "@/components/podkit/lib/cn";

type NotificationDotProps = HTMLAttributes<HTMLSpanElement>;

/**
 * A small red dot that signals "needs attention". Use as an overlay on icon
 * buttons — position it with the `className` prop (the dot is already
 * `absolute`).
 *
 * Purely decorative: the parent element should carry the accessible label.
 */
export const NotificationDot: FC<NotificationDotProps> = ({ className, ...rest }) => (
    <span
        className={cn("absolute size-1.5 rounded-full bg-content-negative", className)}
        aria-hidden="true"
        {...rest}
    />
);
